import {
  FOLLOWER_FEED,
  is_purchase_feed,
  is_ins_feed,
  LIKE_FEED,
  COMMENT_FEED,
  LUCK_COINST_FEED,
  VIDEO_AD_FEED
} from "./../earn_coins_consts/earn_coins_consts";
import { store } from "@/main";
import { payByAny } from "@/services/payment/payment_check/payment_check_logic";
import { Feed } from "../types/type";
// import { playVideoEffect } from "@/services/watch_video";
import {
  GETTER_MASTER_USER_ID,
  GETTER_CURRENT_EARN_COINS_USER_ID
} from "@/store/constants/index_types";
import { UPDATE_GX_USER_INFO } from "@/store/constants/cg_user_types";
import { actFeed } from "@/api/cg/service/feed_service";
import { skip_feeds } from "../controller/feeds_controller";
import { count_limit_feeds } from "./limit_feeds";
import {
  GETTER_CLIENT_SETTINGS,
  GETTER_TAB_COIN_STORE_SETTINGS
} from "@/store/constants/setting_types";
import { GETTER_LOGIN_INS_USER_LIST } from "@/store/constants/ins_user_info_types";
import { act_users_getters } from "@/services/earn_coins/observer/act_users_observer";
import {
  showLoginRequired,
  showCompleteProfile
} from "@/services/dialog_utils/index";
import { earn_spacing_actions } from "@/services/earn_coins/observer/spacing_observer";
import { goToLogin } from "@/utils/router_helper/index";
import { following, liking, commenting } from "./feed_hit";
import { OfferSituation } from "@/services/offer/offer_handle";
import ShowInsVerify from "@/utils/show_ins_verify";
/**
 * 金币类型的购买
 * @param current_feed
 */
export const purchase_feed_act = (current_feed: null | Feed) => {
  if (current_feed && current_feed.offer) {
    const { kind } = current_feed;
    if (kind === LUCK_COINST_FEED) {
      // lucky coins offer特殊:
      const tab_coins_store_setting =
        store.getters[GETTER_TAB_COIN_STORE_SETTINGS];
      const lucky_coin_offers = tab_coins_store_setting.lucky_coin_offers[0];
      payByAny({
        offer: lucky_coin_offers,
        situation: OfferSituation.feed
      });
    } else {
      payByAny({
        offer: current_feed.offer,
        situation: OfferSituation.feed
      });
    }
  }
};

/**
 * 广告类型的feed:
 */
export const ad_feed_act = async () => {
  try {
    // await playVideoEffect("earn_coins");
    // auto move
    skip_feeds();
  } catch (error) {
    //
  }
};

export const auto_play_video = (feed: Feed) => {
  if (feed && feed.kind && feed.kind === VIDEO_AD_FEED) {
    const { earn_limit } = store.getters[GETTER_CLIENT_SETTINGS];
    if (earn_limit && earn_limit.auto_play_video_ads_enabled) {
      ad_feed_act();
    }
  }
};

const ins_feed_act_check = (user_id: string, feed: Feed) => {
  const ins_loggined_user_list = store.getters[GETTER_LOGIN_INS_USER_LIST];
  if (ins_loggined_user_list.length === 0) {
    // 需要登录:
    goToLogin();
    return false;
  }
  const challegeInfo = ShowInsVerify.findChallegeInfo(user_id);
  if (challegeInfo) {
    ShowInsVerify.showVerifyDialog(user_id, challegeInfo.challenge);
    return;
  }

  // 是否需要重新登录:
  if (act_users_getters.is_login_required(user_id)) {
    showLoginRequired(user_id);
    return false;
  }

  // 头像和post需要上传
  // if (act_users_getters.need_complete_profile(user_id)) {
  //   showCompleteProfile(user_id);
  //   return false;
  // }
  // 通过检查:
  return {
    user_id,
    feed
  };
};

const ins_act_request_task = async (
  worker_user_id: string,
  target_id: string,
  feed: Feed
) => {
  try {
    const { kind, subresources } = feed;
    const resource = subresources[0];
    let ins_result: any;
    if (kind === FOLLOWER_FEED) {
      // follow
      ins_result = await following(worker_user_id, target_id);
    } else if (kind === LIKE_FEED) {
      // like
      ins_result = await liking(worker_user_id, target_id);
    } else if (kind === COMMENT_FEED) {
      // comment 类型
      const { comment } = resource; // comment
      const { content } = comment;
      ins_result = await commenting(worker_user_id, target_id, content);
    }
    console.log("ins_result:", ins_result);
    // const { response } = ins_result;
    // const { result } = response;
    return {
      status: "ok",
      message: "ok"
    };
  } catch (error) {
    // 两种错误，ins请求错误
    console.log("ins_result error:", error);
    const { message }: any = error;
    if (message) {
      return {
        status: "fail",
        message
      };
    } else {
      return {
        status: "fail",
        message: "syntax error"
      };
    }
  }
};

const update_user_coins = (masterInfo: any) => {
  store.commit(UPDATE_GX_USER_INFO, {
    userInfo: masterInfo,
    filters: ["coins"]
  });
};

const ins_feed_act_task_loggined = async (work_user_id: string, feed: Feed) => {
  try {
    const { kind, subresources } = feed;
    const resource = subresources[0];
    const { user_id, media_id } = resource;
    const master_id = store.getters[GETTER_MASTER_USER_ID];
    let target_id: any;

    if (kind === FOLLOWER_FEED) {
      // follow
      target_id = user_id; // target id
    } else if (kind === LIKE_FEED && media_id) {
      // like
      target_id = media_id;
    } else if (kind === COMMENT_FEED) {
      // commment
      target_id = media_id;
    }

    // 登陆模式下的任务
    const ins_act_request_task_result = await ins_act_request_task(
      work_user_id,
      target_id,
      feed
    );

    const { status, message } = ins_act_request_task_result;

    const server_result = await actFeed(
      master_id,
      work_user_id,
      status,
      message,
      kind,
      target_id,
      false
    );
    console.log("server_result:", server_result);

    update_user_coins(server_result);
  } catch (error) {
    //
    console.log("ins_feed_act_task error:", error);
  }
};

export const ins_feed_act = async (user_id: string, feed: Feed) => {
  // 开始做任务
  try {
    ins_feed_act_task_loggined(user_id, feed);
    // skip 下一个:
    skip_feeds();
    // count limit follow like count:
    count_limit_feeds(user_id, feed);
    // count spacing:
    earn_spacing_actions.act_trigger();
  } catch (error) {
    //
    console.log("ins_feed_act error:", error);
  }
};

export const act_current_feed = (
  user_id: string,
  current_feed: null | Feed
) => {
  //

  if (current_feed === null || current_feed === undefined) {
    return;
  }

  const { kind } = current_feed;

  if (is_ins_feed(current_feed)) {
    // ins类型的
    const check_result = ins_feed_act_check(user_id, current_feed);

    if (check_result) {
      const { feed } = check_result;
      ins_feed_act(user_id, feed);
    }
  } else if (kind === VIDEO_AD_FEED) {
    // video
    ad_feed_act();
  } else if (is_purchase_feed(current_feed)) {
    // 购买类型的
    purchase_feed_act(current_feed);
  }
};
